export enum FormElementType {
  unknown = -1,

  textField = 1,
  dateTimePicker = 2,

  textArea = 10,

  uploadFiles = 30,
  signature = 31,
  imageUpload = 32,

  dropdown = 50,
  checkboxGroup = 51,
  radioButtonGroup = 52,

  checkbox = 100,
  radioButton = 101,
  dropdownItem = 102,

  heading = 200,
  subheading = 201,

  paragraph = 300,

  stack = 400,
  grid = 401,

  pageBreak =         500,
  divider =           501,
  thirdParty =        502,
  USPSAddress =       503,
  validator =         504,

  // payment =           600
  template = 700,
  lookupField = 701,

  panValidation = 800,
  MMCCProviderValidation = 801,
}